import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/monitorRichiesteCrm';
import { selectors, DEFAULT_STATE } from '../reducers/monitorRichiesteCrm';
import api from '../apis/monitorRichiesteCrm';

const sagas = helper.createSagas('monitorRichiesteCrm', actionTypes, actions, api, selectors, DEFAULT_STATE);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [
    ...defaultSagas
];